import { render, staticRenderFns } from "./perm-error.vue?vue&type=template&id=39d584d2"
import script from "./perm-error.vue?vue&type=script&lang=js"
export * from "./perm-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports